// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

const BetaWrapper = styled.sup`
  text-transform: capitalize;
`;

type Props = {
  text: string,
  t: any,
}

export function BetaTitle({ text, t }: Props) {
  return (
    <div>
      {text} <BetaWrapper>{t('beta')}</BetaWrapper>
    </div>
  );
}

export default translate()(BetaTitle);



// WEBPACK FOOTER //
// ./src/statsradio/components/BetaTitle.js